import { render, staticRenderFns } from "./FlagGrid.vue?vue&type=template&id=7fa63054&scoped=true"
import script from "./FlagGrid.vue?vue&type=script&lang=js"
export * from "./FlagGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa63054",
  null
  
)

export default component.exports